import styled from 'styled-components';
import { Flex } from '@ipc/ipc-components';
import homeDiv from '../../../images/errorBoundaryImage.svg';

export const StyledFlex = styled(Flex)`
  ${({ theme }) => ({
    color: theme.colors.primary,
    fontFamily: theme.fonts.title,
  })}
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  padding: 1rem;
  background: url(${homeDiv}) white no-repeat bottom;
`;

export const StyledTitle = styled.p`
  ${({ theme }) => ({
    fontWeight: theme.fontWeights.bold,
    lineHeight: '3',
    fontSize: theme.fontSizes.title,
  })}
`;
export const StyledSubTitle = styled.p`
  ${({ theme }) => ({
    lineHeight: '2',
    fontSize: theme.fontSizes.md,
  })}
`;
